import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function LoginModal({ isOpen, onLogin, onClose }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    name: "",
    isNewUser: true,
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      console.log("[LOGIN-MODAL] Submitting login with:", {
        email: formData.email,
        isNewUser: formData.isNewUser,
      });

      if (!formData.email.trim()) {
        throw new Error("Email é obrigatório");
      }

      if (!formData.password || formData.password.length < 8) {
        throw new Error("Senha deve ter no mínimo 8 caracteres");
      }

      if (formData.isNewUser && !formData.name.trim()) {
        throw new Error("Nome é obrigatório para novos usuários");
      }

      const credentials = {
        email: formData.email,
        password: formData.password,
        ...(formData.isNewUser && { name: formData.name }),
      };

      console.log("[LOGIN-MODAL] Calling onLogin with:", credentials);
      await onLogin(credentials);
      console.log("[LOGIN-MODAL] Login successful");
      onClose();
    } catch (err) {
      console.error("[LOGIN-MODAL] Error:", err);
      setError(err.message || "Erro ao fazer login");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="w-96 shadow-xl">
        <CardHeader>
          <CardTitle>
            {formData.isNewUser ? "Criar Conta" : "Fazer Login"}
          </CardTitle>
          <CardDescription>
            {formData.isNewUser
              ? "Preencha os dados para se registrar"
              : "Faça login com suas credenciais"}
          </CardDescription>
        </CardHeader>

        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {formData.isNewUser && (
              <div className="space-y-2">
                <Label htmlFor="name">Nome Completo *</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="João Silva"
                  disabled={loading}
                  required
                />
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="email">Email *</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="seu@email.com"
                disabled={loading}
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Senha *</Label>
              <Input
                id="password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Mínimo 8 caracteres"
                disabled={loading}
                required
              />
              {formData.isNewUser && (
                <p className="text-xs text-gray-500">Mínimo 8 caracteres</p>
              )}
            </div>

            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
                {error}
              </div>
            )}

            <div className="flex gap-2 pt-4">
              <Button
                type="submit"
                disabled={loading}
                className="flex-1 bg-vitapink hover:bg-vitapink-700"
              >
                {loading
                  ? "Carregando..."
                  : formData.isNewUser
                    ? "Criar Conta"
                    : "Entrar"}
              </Button>
              <Button
                type="button"
                variant="outline"
                onClick={onClose}
                disabled={loading}
                className="flex-1"
              >
                Cancelar
              </Button>
            </div>

            {formData.isNewUser && (
              <button
                type="button"
                className="w-full text-sm text-gray-600 hover:text-gray-900 p-2"
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    isNewUser: false,
                    name: "",
                  }))
                }
              >
                Já tem conta? Faça login
              </button>
            )}

            {!formData.isNewUser && (
              <button
                type="button"
                className="w-full text-sm text-gray-600 hover:text-gray-900 p-2"
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    isNewUser: true,
                  }))
                }
              >
                Novo por aqui? Criar conta
              </button>
            )}
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
